'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';
import type { PageSection } from '@/lib/cms';

export function CmsCtaSection({ section }: { section: PageSection }) {
  const settings = (section.settings ?? {}) as Record<string, unknown>;
  const items = section.items ?? [];
  const title = (settings.title as string) ?? section.title ?? 'Ready to get started?';
  const description = (settings.description as string) ?? section.content;
  const buttonText = (settings.button_text as string) ?? (items[0]?.button_text as string) ?? 'Get started';
  const buttonLink = (settings.button_link as string) ?? (items[0]?.button_link as string) ?? '/register';

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-soot text-text-inverse">
      <motion.div
        className="max-w-3xl mx-auto text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl font-bold">{title}</h2>
        {description && (
          <p className="mt-4 text-text-inverse/85">{description}</p>
        )}
        <Link
          href={buttonLink}
          className="inline-flex items-center justify-center mt-8 px-8 py-4 bg-plaster text-soot font-semibold rounded-xl hover:shadow-lg transition-all duration-300 hover:scale-[1.02]"
        >
          {buttonText}
        </Link>
      </motion.div>
    </section>
  );
}
